import { Component, computed, inject } from '@angular/core';
import { SignalsStoreService } from '../../../shared/signals-store.service';

@Component({
  selector: 'app-terms-and-conditions',
  imports: [],
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss'
})
export class TermsAndConditionsComponent {
  private signalsStoreService = inject(SignalsStoreService);
  loading: boolean = false;

  termAndCondition = '';

  logoVersionNumber = computed(() => this.signalsStoreService.logoVersionNumber());

}
